export const BASE_URLS: {
  [x: string]: string
} = {
  development: 'http://192.168.0.101:9014/ticpocapi',
  beta: 'https://beta.chem-cloud.cn/ticpocapi',
  production: 'http://ticpoc.chem-cloud.cn/ticpocapi'
}

